import { IOrder, IOrderBasket, IOrderDetailsItem } from "./types";

export default class Order implements IOrder {

  public readonly order: IOrderDetailsItem;
  public readonly basket: IOrderBasket;
  public readonly type: string;

  constructor(order: IOrderDetailsItem, basket: IOrderBasket, type: string) {
    this.order = order;
    this.basket = basket;
    this.type = type;
  }

}
